import * as Yup from 'yup'

export const EnterCodeSchema = Yup.object().shape({
  code: Yup.string().required('Code is required'),
})
